import React, { Component } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import ViewAtmCheckoutRequestForm from './ViewAtmCheckoutRequestForm';


class ViewAtmCheckoutRequest extends Component {
    state = {
        componentSteps: [
            {
                title: 'Get Request Info',
                content: <GetInfo apiLink='requests/getRequest' param request />,
                id: 0,
            },
            {
                title: 'Settle Request',
                content: <ViewAtmCheckoutRequestForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        );
    }
}

export default ViewAtmCheckoutRequest;
